import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData, { getCreatureOffsets } from '../gameData';
import UIAssetKeys from '../UIAssetKeys';
import AquariumItem from './AquariumItem';
import AquariumItemManager from './AquariumItemManager';
import BubbleMaker from './BubbleMaker';

export default class ItemSelector extends Phaser.GameObjects.Container {
  static get EVENT_ITEM_DOWN() {return 'item_down';}

  static get EVENT_ITEM_MOVE() {return 'item_mvoe';}

  static get EVENT_ITEM_RELEASE() {return 'item_release';}

  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {AquariumItemManager} aquarium
   */
  constructor(scene, aquarium) {
    super(scene);

    this.itemEventDelegate = aquarium;

    this.itemContainer = null;
    this.viewMask = null;

    this.menuItems = null;

    this.btnScrollLeft = null;
    this.btnScrollRight = null;

    this.scrollState = null;
    this.vX = null;
    this.speed = null;

    this.minX = 0;
    this.maxX = 0;

    this.maxHeight = null;

    this.menuItems = [];

    this.speed = 10;
    this.vX = 0;

    this.itemContainer = this.scene.add.container();
    this.add(this.itemContainer);
    this.maxHeight = 100;
    this.makeMenuItems(this.maxHeight);
    const viewWidth = 760;
    this.viewMask = this.scene.add.rectangle(4,-4,viewWidth + 50,this.maxHeight + 4, 0xff0000, 1).setOrigin(0)
      .setVisible(false);
    this.itemContainer.mask = this.viewMask.createBitmapMask(this.viewMask);

    // add two boxes that block clicking the items that are hidden by the mask (CreateJs checks mask for input, Phaser 3 does not)
    this.blockingBoxLeft = this.scene.add.rectangle(4,-12, 500, this.maxHeight + 20, 0xffffff, 0).setOrigin(1,0)
      .setInteractive();
    this.blockingBoxRight = this.scene.add.rectangle(viewWidth,-12, 500, this.maxHeight + 20, 0xffffff, 0).setOrigin(0)
      .setInteractive();
    this.add([this.blockingBoxLeft, this.blockingBoxRight]);

    this.btnScrollLeft = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._MenuArrow, this).setOrigin(0)
      .setInteractive();
    this.btnScrollLeft.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onClickRight, this);
    this.btnScrollLeft.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.onReleaseButton, this);
    this.btnScrollLeft.scaleX = -1;
    this.btnScrollLeft.x = 0;
    this.btnScrollLeft.y = this.itemContainer.getBounds().height / 2 - this.btnScrollLeft.height / 2;

    this.btnScrollRight = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._MenuArrow, this).setOrigin(0)
      .setInteractive();
    this.btnScrollRight.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onClickLeft, this);
    this.btnScrollRight.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.onReleaseButton, this);
    this.btnScrollRight.x = viewWidth + this.btnScrollRight.width + 10;
    this.btnScrollRight.y = this.itemContainer.getBounds().height / 2 - this.btnScrollRight.height / 2;

    this.blockingBoxRight.x = viewWidth + this.btnScrollRight.width;

    this.minX = -this.itemContainer.getBounds().width + viewWidth;
    this.maxX = 0;
  }

  makeMenuItems (maxH) {
    const padding = 8;
    let curX = 46;
    let itemWidth = null; let itemHeight = null; let newSize = null;

    // Fishes
    for (let i = 0; i < gameData.FISH_TYPE_COUNT; i++) {
      const fishid = i + 1;
      const offsets = getCreatureOffsets(fishid);
      const item = new AquariumItem(this.scene, 'Fish', fishid, null, null, offsets);
      item.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, (pointer) => {
        this.handleMenuClick(item);
        this.itemEventDelegate.onPickupMenuItem(pointer, item);
      });
      item.on(Phaser.Input.Events.GAMEOBJECT_DRAG, pointer => this.itemEventDelegate.onMoveMenuItem(pointer, item));
      item.on(Phaser.Input.Events.GAMEOBJECT_DRAG_END, () => this.itemEventDelegate.onReleaseMenuItem(item));
      itemHeight = item.getBounds().height;
      itemWidth = item.getBounds().width;
      if (itemHeight > maxH) {
        newSize = resizeDimensions(item.getBounds().width, itemHeight, item.getBounds().width, maxH);
        item.scale = newSize.scale;
      }
      this.itemContainer.add(item);
      this.menuItems.push(item);
      item.initPositionValues(curX, maxH / 2);

      curX += itemWidth + padding;
      if (fishid === 2) {
        curX += 20;
      }
    }

    const plant1 = new BubbleMaker(this.scene,'Plant_1');
    itemWidth = plant1.getBounds().width;
    itemHeight = plant1.getBounds().height;
    plant1.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, (pointer) => {
      this.handleMenuClick(plant1);
      this.itemEventDelegate.onPickupMenuItem(pointer, plant1);
    });
    plant1.on(Phaser.Input.Events.GAMEOBJECT_DRAG, pointer => this.itemEventDelegate.onMoveMenuItem(pointer, plant1));
    plant1.on(Phaser.Input.Events.GAMEOBJECT_DRAG_END, () => this.itemEventDelegate.onReleaseMenuItem(plant1));
    if (itemHeight > maxH) {
      newSize = resizeDimensions(itemWidth, itemHeight, itemWidth, maxH);
      plant1.scale = newSize.scale;
    }
    plant1.x = curX;
    plant1.y = maxH / 2;
    this.itemContainer.add(plant1);
    this.menuItems.push(plant1);
    curX += itemWidth + padding + 40;

    const plant2 = new BubbleMaker(this.scene,'Plant_2');
    itemWidth = plant2.getBounds().width;
    itemHeight = plant2.getBounds().height;
    plant2.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, (pointer) => {
      this.handleMenuClick(plant2);
      this.itemEventDelegate.onPickupMenuItem(pointer, plant2);
    });
    plant2.on(Phaser.Input.Events.GAMEOBJECT_DRAG, pointer => this.itemEventDelegate.onMoveMenuItem(pointer, plant2));
    plant2.on(Phaser.Input.Events.GAMEOBJECT_DRAG_END, () => this.itemEventDelegate.onReleaseMenuItem(plant2));
    if (itemHeight > maxH) {
      newSize = resizeDimensions(itemWidth, itemHeight, itemWidth, maxH);
      plant2.scale = newSize.scale;
    }
    plant2.x = curX;
    plant2.y = maxH / 2;
    this.itemContainer.add(plant2);
    this.menuItems.push(plant2);
    curX += itemWidth + padding + 40;

    const plant3 = new BubbleMaker(this.scene,'Plant_3');
    itemWidth = plant3.getBounds().width;
    itemHeight = plant3.getBounds().height;
    plant3.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, (pointer) => {
      this.handleMenuClick(plant3);
      this.itemEventDelegate.onPickupMenuItem(pointer, plant3);
    });
    plant3.on(Phaser.Input.Events.GAMEOBJECT_DRAG, pointer => this.itemEventDelegate.onMoveMenuItem(pointer, plant3));
    plant3.on(Phaser.Input.Events.GAMEOBJECT_DRAG_END, () => this.itemEventDelegate.onReleaseMenuItem(plant3));
    if (itemHeight > maxH) {
      newSize = resizeDimensions(itemWidth, itemHeight, itemWidth, maxH);
      plant3.scale = newSize.scale;
    }
    plant3.x = curX;
    plant3.y = maxH / 2;
    this.itemContainer.add(plant3);
    this.menuItems.push(plant3);
    curX += itemWidth + padding + 40;

    // Friends
    for (let i = 0; i < 6; i++) {
      const fishid = i + 1;
      const offsets = getCreatureOffsets(`Friend${fishid}`);
      const item = new AquariumItem(this.scene, 'Friend', fishid, null, null, offsets);
      if (i === 1 || i === 3) {
        item.sinks = true;
      }
      if (i === 4) {
        item.rotates = true;
      }
      item.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, (pointer) => {
        this.handleMenuClick(item);
        this.itemEventDelegate.onPickupMenuItem(pointer, item);
      });
      item.on(Phaser.Input.Events.GAMEOBJECT_DRAG, pointer => this.itemEventDelegate.onMoveMenuItem(pointer, item));
      item.on(Phaser.Input.Events.GAMEOBJECT_DRAG_END, () => this.itemEventDelegate.onReleaseMenuItem(item));
      itemHeight = item.getBounds().height;
      itemWidth = item.getBounds().width;
      if (itemHeight > maxH) {
        newSize = resizeDimensions(item.getBounds().width, itemHeight, item.getBounds().width, maxH);
        item.scale = newSize.scale;
      }
      this.itemContainer.add(item);
      this.menuItems.push(item);

      item.initPositionValues(curX, maxH / 2);
      curX += itemWidth + padding;
      if (i === 1) {
        curX += 28;
      }
    }
  }

  /**
   * 
   * @param {AquariumItem | BubbleMaker} item 
   */
  handleMenuClick (item) {
    const index = this.menuItems.indexOf(item);
    this.menuItems.splice(index,1);

    if (item.itemType === 'Fish') {
      this.makeNewMenuAquariumItem(item);
      item.doAnimatedSwim();
    }
    else if (item.itemType === 'BubbleMaker') {
      this.makeNewBubbleMakerItem(item);
    }
  }

  /**
   * 
   * @param {AquariumItem} oldItem 
   */
  makeNewMenuAquariumItem (oldItem) {
    const itemName = oldItem.itemName;
    const itemID = oldItem.itemID;
    let offsets = null; let item = null;
    if (itemName === 'Fish') {
      offsets = getCreatureOffsets(itemID);
      item = new AquariumItem(this.scene, 'Fish', itemID, null, null, offsets);
    }
    else if (itemName === 'Friend') {
      offsets = getCreatureOffsets(`Friend${itemID}`);
      item = new AquariumItem(this.scene, 'Friend', itemID, null, null, offsets);
      item.sinks = oldItem.sinks;
      item.rotates = oldItem.rotates;
    }

    item.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, (pointer) => {
      this.handleMenuClick(item);
      this.itemEventDelegate.onPickupMenuItem(pointer, item);
    });
    item.on(Phaser.Input.Events.GAMEOBJECT_DRAG, pointer => this.itemEventDelegate.onMoveMenuItem(pointer, item));
    item.on(Phaser.Input.Events.GAMEOBJECT_DRAG_END, () => this.itemEventDelegate.onReleaseMenuItem(item));
    const itemHeight = item.getBounds().height;
    if (itemHeight > this.maxHeight) {
      const newSize = resizeDimensions(item.getBounds().width, itemHeight, item.getBounds().width, this.maxHeight);
      item.scale = newSize.scale;
    }
    item.x = oldItem.x;
    item.y = oldItem.y;
    this.itemContainer.add(item);
    this.menuItems.push(item);
  }

  /**
   * 
   * @param {BubbleMaker} oldItem 
   */
  makeNewBubbleMakerItem (oldItem) {
    const item = new BubbleMaker(this.scene, oldItem.spritename);
    const itemWidth = item.getBounds().width;
    const itemHeight = item.getBounds().height;
    item.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, (pointer) => {
      this.handleMenuClick(item);
      this.itemEventDelegate.onPickupMenuItem(pointer, item);
    });
    item.on(Phaser.Input.Events.GAMEOBJECT_DRAG, pointer => this.itemEventDelegate.onMoveMenuItem(pointer, item));
    item.on(Phaser.Input.Events.DRAG_END, () => this.itemEventDelegate.onReleaseMenuItem(item));
    if (itemHeight > this.maxHeight) {
      const newSize = resizeDimensions(itemWidth, itemHeight, itemWidth, this.maxHeight);
      item.scale = newSize.scale;
    }
    item.x = oldItem.x;
    item.y = oldItem.y;
    this.itemContainer.add(item);
    this.menuItems.push(item);
  }

  onClickLeft () {
    this.scrollState = STATE_LEFT;
    this.vX = -this.speed;
  }

  onClickRight () {
    this.scrollState = STATE_RIGHT;
    this.vX = this.speed;
  }

  onReleaseButton () {
    this.scrollState = null;
    this.vX = 0;
  }

  tick (delta) {
    if (this.itemContainer.x >= this.minX && this.itemContainer.x <= this.maxX) {
      this.itemContainer.x += this.vX;
      if (this.itemContainer.x < this.minX) {
        this.itemContainer.x = this.minX;
      }
      if (this.itemContainer.x > this.maxX) {
        this.itemContainer.x = this.maxX;
      }
    }

    const len = this.menuItems.length;
    for (let i = 0; i < len; i++) {
      if (this.menuItems[i].menuTick) this.menuItems[i].menuTick(delta);
    }
  }

  preUpdate() {
    this.viewMask.setPosition(this.x + 4, this.y - 4);
  }
}

const STATE_LEFT = 'left';
const STATE_RIGHT = 'right';

function resizeDimensions(currentWidth, currentHeight, maxWidth, maxHeight) {
  let imageWidth = currentWidth;
  let imageHeight = currentHeight;
  let imageScale = 1.0;
  if (imageWidth > imageHeight) {
    if (imageWidth > maxWidth) {
      imageScale = maxWidth / imageWidth;
      imageHeight *= imageScale;
      imageWidth = maxWidth;
    }
    else {
      if (imageHeight > maxHeight) {
        imageScale = maxHeight / imageHeight;
        imageWidth *= imageScale;
        imageHeight = maxHeight;
      }
    }
  }
  else {
    if (imageHeight > maxHeight) {
      imageScale = maxHeight / imageHeight;
      imageWidth *= imageScale;
      imageHeight = maxHeight;
    }
  }
  return { width: imageWidth, height: imageHeight, scale: imageScale };
}